import { RootStateInterface } from '@/store/rootState';
import { Module, MutationTree } from 'vuex';
import { IntroducerStateInterface } from '../interfaces/IntroducerStateInterface';

export const state: IntroducerStateInterface = {
    id: null,
    user: null,
    phoneNumber: null,
    introducerBrokers: null,
    introducerCompanies: null,
}

export const mutations: MutationTree<IntroducerStateInterface> = {
    updateIntroducer(st: IntroducerStateInterface, payload: IntroducerStateInterface) {
        console.log('updating introducer state', payload);
        st.id = payload.id;
        st.user = payload.user;
        st.phoneNumber = payload.phoneNumber;
        st.introducerBrokers = payload.introducerBrokers;
        st.introducerCompanies = payload.introducerCompanies;
    },
    clearState(st: IntroducerStateInterface) {
        st.id = null;
        st.user = null;
        st.phoneNumber = null;
        st.introducerBrokers = null;
        st.introducerCompanies = null;
    }
};


const namespaced: boolean = true;

export const introducer: Module<IntroducerStateInterface, RootStateInterface> = {
    namespaced,
    state,
    mutations,
}
